import { WorkspaceRole } from '~api/workspaces/getWorkspaceMembers';

import { translate } from '~l10n/client';

/**
 * Roles offered in the invite dialog, in display order (Admin → Editor →
 * Viewer). Owner is never an invite role — ownership only moves via transfer.
 */
export const INVITE_ROLE_ORDER: WorkspaceRole[] = [
  WorkspaceRole.Admin,
  WorkspaceRole.Editor,
  WorkspaceRole.Viewer,
];

// Static `translate()` calls (not a lookup map) so l10n extraction sees each
// literal string.
export const inviteRoleLabel = (role: WorkspaceRole): string => {
  switch (role) {
    case WorkspaceRole.Admin:
      return translate('Admin');
    case WorkspaceRole.Viewer:
      return translate('Viewer');
    case WorkspaceRole.Editor:
    default:
      return translate('Editor');
  }
};

export const inviteRoleDescription = (role: WorkspaceRole): string => {
  switch (role) {
    case WorkspaceRole.Admin:
      return translate(
        'Can manage members, roles, and library settings. Can do everything Editors can.'
      );
    case WorkspaceRole.Viewer:
      return translate(
        'Can view and export library content. Can view members and invite other Viewers.'
      );
    case WorkspaceRole.Editor:
    default:
      return translate(
        'Can edit library content and invite other Editors and Viewers.'
      );
  }
};
